module.exports = __webpack_public_path__ + "static/turtle-creek-house01-5b54a263263841017a9f807c25f9685b.jpg";